module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-az-6dcb76b94a7f6e5c7779607209b542dd.png";